import React from 'react';

import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { HotelDetailsWrapper } from '@components';
import { scrollTop } from '@share/utils';

import './style.scss';

interface IProps extends RouteComponentProps {
  isVacationRentals?: boolean;
}

class HotelDetailPageComponent extends React.Component<IProps> {
  componentDidMount(): void {
    scrollTop();
  }

  render(): React.ReactNode {
    return (
      <div className="hotel-details-page">
        <HotelDetailsWrapper isVacationRentals={this.props.isVacationRentals || false} />
      </div>
    );
  }
}

export const HotelDetailPage = connect()(withRouter(HotelDetailPageComponent));
